<template>
    <div v-if="showPreviewPopup">
      <div class="popupModal" :class="{active: showPreviewPopup}">
        <div class="popupModal__wrapper">
          <div class="popupModal__content">
            <div class="main-content">
              <div class="previewImage__wrapper">
                <img :src="settings.image" alt="" class="previewImage">
              </div>
            </div>
            <template>
              <div class="footer-cancel__btn" @click="onClose">
                <template>{{ translate('Close') }}</template>
              </div>
            </template>
          </div>

        </div>

      </div>
    </div>
</template>

<script>
    import logAnalyticsEvent from '@/helpers/analytics'
    import errorMixin from '@/mixins/errorMixin';
    import pageLoader from "./pageLoader";

    export default {
      name: "geolocationLoadingPopup",
      mixins: [errorMixin],

      data() {
        return {
          showPreviewPopup: this.settings !== null,
        }
      },

      watch: {
        settings(newValue) {
          this.showPreviewPopup = newValue !== null
        }
      },

      props: {
        settings: {
          type: [Object, null],
          default: () => {
            return {}
          }
        },
      },

      methods: {
        async onClose() {
          logAnalyticsEvent('gps_loading_popup_close_click')
          this.showPreviewPopup = false
          if (this.settings.onCancelHandler) {
            try {
              await this.settings.onCancelHandler(this.settings)
            } catch (error) {
              this.showErrorModal(error.message)
            }
          }
        },
      }

    }
</script>

<style scoped>
    .page-loader {
      display: flex;
      justify-content: center;
      align-items: center;
      position: inherit;
      top: 0;
      left: 0;
      width: 200px;
      height: 100px;
      background: rgba(47, 47, 47, 0);
      z-index: 999;
    }


    .footer-cancel__btn {
      cursor: pointer;
      text-align: center;
    }

    .main-content {
      text-align: center;
      color: black;
      margin-bottom: 15px;
      margin-top: 25px;
    }

    .main-content__title {
      margin-top: 0;
      color: black;
      margin-bottom: 20px;
    }
    .previewImage {
      max-width: 370px;
      max-height: 400px;
    }

    @media screen and (max-width: 376px) {
      .previewImage {
        max-width: 300px;
      }
    }
    @media screen and (max-width: 321px) {
      .previewImage {
        max-width: 270px;
      }
    }


</style>


